<template>
  <div
    v-if="hasPreviousPage"
    class="flex justify-center"
  >
    <VButtonOutlineAnimated
      :disabled="isFetchingPreviousPage"
      class="my-6"
      @click="params.page = data.pages.at(0).data.paginator.current_page - 1, fetchPreviousPage()"
    >
      {{ trans.get('miliboo.common.previous') }}
    </VButtonOutlineAnimated>
  </div>
  <template v-if="to">
    <div class="container mx-auto px-4 md:px-6 lg:px-8 py-12">
      <ul class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-12 md:gap-x-12">
        <template
          v-for="(page, index) in data.pages"
          :key="index"
        >
          <li
            v-for="product in page.data.paginator.data"
            :key="product.id"
          >
            <ProductCard
              :wished="isFetching ? null : wishes.includes(product.id)"
              :product="product"
              :shop="shop"
            />
          </li>
        </template>
      </ul>
      <VVisibilityState @visible="$event && !isFetching && showMore.$emit('click')">
        <TheShowMore
          ref="showMore"
          :disabled="isFetchingNextPage"
          :pages="data.pages"
          @click="hasNextPage && (params.page = data.pages.at(data.pages.length - 1).data.paginator.current_page + 1, fetchNextPage())"
        />
      </VVisibilityState>
      <slot v-if="false" />
      <ThePagination
        v-else
        :seo="true"
        :paginator="data.pages.at(data.pages.length - 1).data.paginator"
      />
    </div>
  </template>
</template>

<script setup>
import {
  computed, onMounted, inject, ref,
} from 'vue';
import ProductCard from './components/ProductCard.vue';
import VButtonOutlineAnimated from '../../components/buttons/VButtonOutlineAnimated.vue';
import TheShowMore from '../../components/pagination/TheShowMore.vue';
import useUrlParams from '../../composables/useUrlParams';
import VVisibilityState from '../../components/state/VVisibilityState.vue';
import useProductList from './composables/useProductList';
import ThePagination from '../../components/common/ThePagination.vue';
import useViewItemsListTags from './composables/useViewItemsListTags';

const props = defineProps({
  paginator: {
    type: Object,
    required: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  sorts: {
    type: Array,
    required: true,
  },
  productList: {
    type: Object,
    default: null,
  },
  shop: {
    type: Object,
    required: true,
  },
  netwaveCategoryCode: {
    type: Number,
    default: null,
  },
});

const trans = inject('translate');

const showMore = ref();

const {
  data,
  wishes,
  isFetching,
  isFetchingNextPage,
  isFetchingPreviousPage,
  fetchNextPage,
  fetchPreviousPage,
  hasPreviousPage,
  hasNextPage,
} = useProductList(props.paginator, props.filters, props.sorts, props.productList);

const { listTags } = useViewItemsListTags(props.paginator, props.productList, props.netwaveCategoryCode);

const params = useUrlParams();

const to = computed(() => data.value?.pages?.reduce((partialSum, page) => partialSum + page.data.paginator.data.length, 0));

onMounted(() => {
  listTags();
});

</script>
